if (!customElements.get('pawce-product-details')) {
  customElements.define('pawce-product-details', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const on = (el, name, fn) => el.addEventListener(name, fn, {signal: this.events.signal});
      this.dialog = this.querySelector('dialog');
      this.opener = this.querySelector('[data-details-open]');
      on(this.opener, 'click', () => this.open());
      on(this.querySelector('[data-details-close]'), 'click', () => this.dialog.close());
      on(this.dialog, 'click', e => { if (e.target === this.dialog) { const r = this.dialog.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) this.dialog.close(); } });
      on(this.dialog, 'close', () => this.restore());
      on(document, 'shopify:block:select', e => { if (e.target === this || this.contains(e.target)) { this.open(); } });
    }
    open() {
      if (this.dialog.open) return;
      this.returnFocus = this.opener;
      this.previousOverflow = document.documentElement.style.overflow;
      this.dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
    }
    restore() {
      if (this.previousOverflow !== undefined) document.documentElement.style.overflow = this.previousOverflow;
      this.previousOverflow = undefined;
      if (this.returnFocus?.isConnected) this.returnFocus.focus({preventScroll: true});
    }
    disconnectedCallback() { this.restore(); this.events?.abort(); }
  });
}
